import Modal from "@ui-components/Modal";
import {ShowWorksitesModalProps} from "./Resales.type";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import CountryContext from "../../../CountryContext";
import { useContext } from "react";
import MaterialTable from "@material-table/core";
import TableStyle from "@components/TableStyle";
import { useIntl } from "react-intl";


export const ShowWorksitesModal = ({
  worksites,
  onExit
}:ShowWorksitesModalProps) => {
  const {
    country: {code},
  } = useContext(CountryContext);
  const intl = useIntl();
  const columns = [
    {
      title: '',//intl.formatMessage({id:'worksite', defaultMessage:'Cantiere'}),
      field: 'description',
      render: (rowData: any) => {
        return <div><Link
          to={`/${code}/worksites/${rowData.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ArrowTopRightOnSquareIcon className="inline w-4 -mt-0.5 text-kerakoll-700"/>
        </Link>
          <span className={"ml-2"}>{rowData.description}</span>
        </div>
      }
    }
  ]
  const data = worksites.map(worksite => {
    return {
      description: worksite.split('__')[1],
      id: worksite.split('__')[0]
    }
  })
  return <Modal
    onExit={onExit}
  >
    <div className={"mt-8"}>
      <TableStyle>
        <MaterialTable
          title={intl.formatMessage({id:'worksites', defaultMessage:'Cantieri'})}
          data={data}
          columns={columns}
          options={{
            paging: true,
            filtering: true,
            sorting: true,
            search: false
          }}
        />
      </TableStyle>
    </div>
  </Modal>
}